module.exports = __webpack_public_path__ + "img/templateManage-active.d766ce86.svg";